import { Fragment } from 'react';
import { jsx } from 'react/jsx-runtime';

function FragmentWithoutProps(props) {
  var children = props.children;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
}

export { FragmentWithoutProps };
